import React from 'react';
import { Link } from 'react-router-dom';

const EmptyState = ({ icon: Icon, title, subtitle, actionLabel, actionHref, onAction }) => (
  <div className="cp-empty">
    {Icon && <div className="cp-empty-icon"><Icon /></div>}
    <div className="cp-empty-title">{title || 'Sin datos'}</div>
    {subtitle && <div className="cp-empty-text">{subtitle}</div>}
    {actionLabel && onAction && (
      <button type="button" onClick={onAction} className="cp-btn cp-btn-outline cp-btn-sm" style={{ marginTop: 16 }}>{actionLabel}</button>
    )}
    {actionLabel && actionHref && !onAction && (
      <Link to={actionHref} className="cp-btn cp-btn-outline cp-btn-sm" style={{ marginTop: 16 }}>{actionLabel}</Link>
    )}
  </div>
);

export default EmptyState;
